var React = require("react");
var SelectDropdown = require('patternity/lib/select_dropdown');
var { withNamespaces } = require('react-i18next');

var Sort = React.createClass({
  propTypes: {
    selectedChallengeSort: React.PropTypes.string.isRequired,
    onChange: React.PropTypes.func.isRequired
  },

  render: function(){
    return (
      <div className='challenge-sort-control'>
        <span className='sort-control-label'>{this.props.t('Sort by')}</span>
        <SelectDropdown id="challenge-sort" key="challenge-sort"
          value={this.props.selectedChallengeSort}
          onChange={this._onSortChange}
        >
          <option key="key0" value="">{this.props.t('Select...')}</option>
          {this._selectOptions()}
        </SelectDropdown>
      </div>
    );
  },

  _selectOptions : function(){
    var sortOptions = [
      { name: this.props.t('Highest Points'), value: "most_points" },
      { name: this.props.t('Most Recent'),    value: "most_recent_published" },
      { name: this.props.t('Most Popular'),   value: "most_popular" },
      { name: this.props.t('Oldest'),         value: "first_published" }
    ];

    var options = [];
    sortOptions.forEach(function(option){
      options.push(<option key={option.value} value={option.value}>{option.name}</option>);
    });

    return options;
  },

  _onSortChange : function(event){
    var selectedValue = event.target.options[event.target.selectedIndex].value;

    app.analytics.logEvent('Challenges Sorting', {sortingOption: selectedValue});
    this.props.onChange({sort: selectedValue});
  }
});

module.exports = withNamespaces()(Sort);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/sort.jsx